import { css } from 'styled-components';
import WavyPatternBlack from 'assets/wavy_pattern_black.png';

export const TeamSummaryEventStyles = css`
  .b-sch-event-wrap.team_allocation_summary,
  .b-sch-event-wrap.company_allocation_summary {
    height: 40px;
    top: -12px;

    .b-sch-event {
      border-radius: 0px;
      &.soft {
        overflow: hidden !important;
        &::after {
          content: '';
          position: absolute;
          background-image: url(${WavyPatternBlack});
          background-size: contain;
          height: 120%;
          width: max(100%, 60px);
          opacity: 9%;
        }
      }
      &.b-sch-event-selected .b-sch-event-content .content,
      .content {
        color: var(--yellow-90) !important;
      }
    }

    .b-sch-event-content,
    &.b-sch-event-selected .b-sch-event-content {
      width: unset;

      .content {
        width: unset;
        font-weight: var(--font-weight-bold) !important;
      }
    }
  }
  .b-sch-event-wrap.company_allocation_summary {
    .b-sch-event {
      background-color: var(--yellow-40);
      border-color: var(--yellow-40);
      &:hover {
        background-color: var(--yellow-40);
        border-color: var(--yellow-40);
      }
    }
  }
  .b-sch-event-wrap.team_allocation_summary {
    .b-sch-event {
      background-color: var(--yellow-20);
      border-color: var(--yellow-20);
      &:hover {
        background-color: var(--yellow-20);
        border-color: var(--yellow-20);
      }
    }
  }
`;
